import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card w-100 h-100 d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column align-items-start"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, "Error", -1 /* HOISTED */)
const _hoisted_4 = { class: "font-size-xl mb-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" There was problem while loading the referral. Please try again. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" There was problem while generating the referral form. Please try again. ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl" }, "Loading Referral Form...", -1 /* HOISTED */)
const _hoisted_10 = {
  key: 2,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl text-center" }, "Saving Referral...", -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { id: "HomeHealth_New_Referral" }
const _hoisted_15 = { class: "convert-header" }
const _hoisted_16 = { class: "card m-2" }
const _hoisted_17 = { class: "card-body form-content p-3 mx-lg-6" }
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = { class: "d-flex flex-column px-4 py-2" }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = { class: "d-flex flex-column px-4 py-2" }
const _hoisted_25 = { class: "form-group col-12" }
const _hoisted_26 = {
  key: 0,
  class: "d-flex justify-content-center form-footer m-1 gap-2 mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferralSourceInformation = _resolveComponent("ReferralSourceInformation")!
  const _component_DemographicsInformation = _resolveComponent("DemographicsInformation")!
  const _component_PatientTags = _resolveComponent("PatientTags")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _component_PayorInformation = _resolveComponent("PayorInformation")!
  const _component_ClinicalInformation = _resolveComponent("ClinicalInformation")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createBlock(_component_PageLayout, {
    "has-buttons": true,
    "has-title": false,
    "content-class": "p-0",
    "has-page-scroll": false
  }, _createSlots({
    default: _withCtx(() => [
      (_ctx.isLoadError || _ctx.isFormLoading || _ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_ctx.isLoadError && !_ctx.isFormLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, [
                    (_ctx.referralId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_5
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_6
                        ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  _hoisted_7,
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadReferral()))
                  }, "Try Again")
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.isFormLoading && !_ctx.isLoadError)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_8,
                  _hoisted_9
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (_ctx.isSaveInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(`${!_ctx.isCreate ? "Edit" : "Create"} Home Health Referral-${_ctx.formatName(
                            _ctx.referral.Referral.FirstName,
                            _ctx.referral.Referral.LastName
                        )}`), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_ReferralSourceInformation, {
                      "referral-options": _ctx.referralOptions,
                      referral: _ctx.referral,
                      "is-editing": !_ctx.isCreate,
                      "same-as-certifying-physician": _ctx.sameAsCertifyingPhysician
                    }, null, 8 /* PROPS */, ["referral-options", "referral", "is-editing", "same-as-certifying-physician"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_DemographicsInformation, {
                      "referral-options": _ctx.referralOptions,
                      referral: _ctx.referral,
                      "branch-id": _ctx.branchId,
                      "is-editing": !_ctx.isCreate,
                      isRefer: _ctx.isRefer,
                      "enable-validation": _ctx.isPatientIdentifierEnabled,
                      onChangeBranchId: _ctx.changeBranchId
                    }, null, 8 /* PROPS */, ["referral-options", "referral", "branch-id", "is-editing", "isRefer", "enable-validation", "onChangeBranchId"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_FormSection, {
                      title: "Tags",
                      "full-height": false,
                      "application-id": _ctx.referral.application
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("section", _hoisted_21, [
                          _createVNode(_component_PatientTags, { patient: _ctx.referral }, null, 8 /* PROPS */, ["patient"])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["application-id"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_PayorInformation, {
                      "referral-options": _ctx.referralOptions,
                      referral: _ctx.referral,
                      "branch-id": _ctx.branchId,
                      "is-editing": !_ctx.isCreate,
                      "is-refer": _ctx.isRefer,
                      "enable-validation": _ctx.isPatientIdentifierEnabled
                    }, null, 8 /* PROPS */, ["referral-options", "referral", "branch-id", "is-editing", "is-refer", "enable-validation"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_ClinicalInformation, {
                      "referral-options": _ctx.referralOptions,
                      referral: _ctx.referral,
                      "is-editing": !_ctx.isCreate,
                      "is-refer": _ctx.isRefer,
                      "change-certifying-physician": _ctx.countPhysicianChange,
                      "get-certifying-physician": _ctx.getCertifyingPhysician
                    }, null, 8 /* PROPS */, ["referral-options", "referral", "is-editing", "is-refer", "change-certifying-physician", "get-certifying-physician"])
                  ]),
                  _createVNode(_component_FormSection, {
                    title: "Referral Comments",
                    "full-height": false,
                    "application-id": _ctx.referral.application
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("section", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_CommentInput, {
                            "input-name": "referral-comments",
                            result: _ctx.referral.Referral.Comments,
                            onResultUpdatedAppended: _ctx.resultUpdatedAppended,
                            onResultUpdated: _ctx.resultUpdated,
                            placeholder: "Enter Comments",
                            "class-list": _ctx.commentInputClass,
                            application: _ctx.referral.application,
                            "max-length": 2000
                          }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "class-list", "application"])
                        ])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["application-id"])
                ])
              ]),
              (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
                ? (_openBlock(), _createElementBlock("footer", _hoisted_26, [
                    (!_ctx.isCreate)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-primary me-2",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update()))
                        }, " Save Referral "))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-primary me-2",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.create()))
                        }, "Create Referral")),
                    _createElementVNode("button", {
                      class: "btn btn-outline-primary me-2",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToReferralList()))
                    }, "View Referral List"),
                    _createElementVNode("button", {
                      class: "btn btn-outline-primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToReferralList(true)))
                    }, "Cancel")
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        }
      : undefined
  ]), 1024 /* DYNAMIC_SLOTS */))
}